/**
 * Missed Auctions filters: Show Time (showDate) and Presenter Name (presenterName).
 * Cross-filter: applied Presenters narrow Show Time options; applied Show Times narrow Presenter options.
 * Desktop: dropdown panels with checkboxes. Mobile: popup with checkboxes.
 * Integrates with app.js runLast24Hours via setHours() and "missed-filters-change" event.
 */
(function () {
  'use strict';

  var CHECKMARK_SVG = '<svg viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4l2.5 2.5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function getState(container) {
    if (!container._missedFiltersState) {
      container._missedFiltersState = {
        showTime: [],
        presenter: [],
        draftShowTime: [],
        draftPresenter: [],
        hours: []
      };
    }
    return container._missedFiltersState;
  }

  function getTypeKey(typeAttr) {
    return typeAttr === 'show-time' ? 'showTime' : 'presenter';
  }

  function getDraftKey(typeKey) {
    return typeKey === 'showTime' ? 'draftShowTime' : 'draftPresenter';
  }

  function getDraftSelection(state, typeKey) {
    return state[getDraftKey(typeKey)];
  }

  function resetDraftFromApplied(container, typeKey) {
    var state = getState(container);
    state[getDraftKey(typeKey)] = state[typeKey].slice();
  }

  function applyDraftSelection(container, typeKey) {
    var state = getState(container);
    state[typeKey] = getDraftSelection(state, typeKey).slice();
    updateTriggerText(container, typeKey);
  }

  function buildOption(type, value, label, selected) {
    var isPopup = type === 'popup';
    var option = document.createElement('button');
    option.type = 'button';
    option.className = isPopup ? 'missed-filters__popup-option' : 'missed-filters__option';
    option.setAttribute('role', 'option');
    option.setAttribute('aria-selected', selected ? 'true' : 'false');
    option.dataset.filterValue = String(value);
    if (selected) option.classList.add('is-selected');

    var checkbox = document.createElement('span');
    checkbox.className = 'missed-filters__option-checkbox';
    checkbox.setAttribute('aria-hidden', 'true');
    checkbox.innerHTML = selected ? CHECKMARK_SVG : '';
    option.appendChild(checkbox);

    var text = document.createElement('span');
    text.textContent = label;
    option.appendChild(text);

    return option;
  }

  function renderOptions(container, state) {
    var showTimeOpts = state.showTimeOptions || [];
    var presenterOpts = state.presenterOptions || [];

    function fillPanel(panelEl, opts, typeKey) {
      if (!panelEl) return;
      var inner = panelEl.querySelector('[data-filter-options]');
      if (!inner) return;
      inner.innerHTML = '';
      var selectedSet = getDraftSelection(state, typeKey);
      opts.forEach(function (opt) {
        var selected = selectedSet.indexOf(opt.id) !== -1;
        var btn = buildOption(panelEl.classList.contains('missed-filters__popup-panel') ? 'popup' : 'desktop', opt.id, opt.label, selected);
        btn.addEventListener('click', function () {
          toggleOption(container, typeKey, opt.id);
          syncOptionsUI(container, typeKey);
          if (panelEl.classList.contains('missed-filters__popup-panel')) {
            dispatchChange(container);
          }
          /* Desktop: apply on Done click, not on each option */
        });
        inner.appendChild(btn);
      });
    }

    var popups = container._missedFiltersPopups || {};
    var showTimeDesktop = container.querySelector('.missed-filters__dropdown--show-time [data-filter-panel]');
    var presenterDesktop = container.querySelector('.missed-filters__dropdown--presenter [data-filter-panel]');
    var showTimePopupEl = popups['show-time'];
    var presenterPopupEl = popups['presenter'];
    var showTimePopup = showTimePopupEl && showTimePopupEl.querySelector('[data-filter-options]');
    var presenterPopup = presenterPopupEl && presenterPopupEl.querySelector('[data-filter-options]');

    fillPanel(showTimeDesktop, showTimeOpts, 'showTime');
    fillPanel(presenterDesktop, presenterOpts, 'presenter');

    if (showTimePopup) {
      showTimePopup.innerHTML = '';
      showTimeOpts.forEach(function (opt) {
        var selected = state.draftShowTime.indexOf(opt.id) !== -1;
        var btn = buildOption('popup', opt.id, opt.label, selected);
        btn.addEventListener('click', function () {
          toggleOption(container, 'showTime', opt.id);
          syncOptionsUI(container, 'showTime');
        });
        showTimePopup.appendChild(btn);
      });
    }
    if (presenterPopup) {
      presenterPopup.innerHTML = '';
      presenterOpts.forEach(function (opt) {
        var selected = state.draftPresenter.indexOf(opt.id) !== -1;
        var btn = buildOption('popup', opt.id, opt.label, selected);
        btn.addEventListener('click', function () {
          toggleOption(container, 'presenter', opt.id);
          syncOptionsUI(container, 'presenter');
        });
        presenterPopup.appendChild(btn);
      });
    }

    container.querySelectorAll('.missed-filters__panel').forEach(applySearchFilter);
    Object.keys(popups).forEach(function (key) {
      applySearchFilter(popups[key].querySelector('.missed-filters__popup-panel'));
    });
  }

  /** Hide options whose label does not contain the text typed in the panel's search box. */
  function applySearchFilter(panel) {
    if (!panel) return;
    var input = panel.querySelector('[data-filter-search]');
    var query = input ? input.value.trim().toLowerCase() : '';
    panel.querySelectorAll('[data-filter-value]').forEach(function (opt) {
      opt.hidden = query !== '' && opt.textContent.toLowerCase().indexOf(query) === -1;
    });
  }

  function filterPanelOf(el) {
    return el && el.closest('.missed-filters__panel, .missed-filters__popup-panel');
  }

  function bindSearch(root) {
    root.querySelectorAll('[data-filter-search]').forEach(function (input) {
      if (input._missedSearchBound) return;
      input._missedSearchBound = true;
      input.addEventListener('input', function () {
        applySearchFilter(filterPanelOf(input));
      });
    });
  }

  /** A freshly opened panel starts with an empty search and every option visible. */
  function clearSearch(root) {
    if (!root) return;
    root.querySelectorAll('[data-filter-search]').forEach(function (input) {
      input.value = '';
      applySearchFilter(filterPanelOf(input));
    });
  }

  function toggleOption(container, typeKey, value) {
    var state = getState(container);
    var arr = getDraftSelection(state, typeKey);
    var i = arr.indexOf(value);
    if (i === -1) arr.push(value);
    else arr.splice(i, 1);
  }

  function updateTriggerText(container, typeKey) {
    var state = getState(container);
    var count = typeKey === 'showTime' ? state.showTime.length : state.presenter.length;
    var typeAttr = typeKey === 'showTime' ? 'show-time' : 'presenter';
    var dropdown = container.querySelector('.missed-filters__dropdown--' + typeAttr);
    var label = (dropdown && dropdown.getAttribute('data-filter-label')) || (typeKey === 'showTime' ? 'Show Time' : 'Presenter Name');
    var mobileLabel = typeKey === 'presenter' ? 'Presenter' : label;
    var text = count > 0 ? label + ' (' + count + ')' : label;
    var mobileText = count > 0 ? mobileLabel + ' (' + count + ')' : mobileLabel;

    var triggerTextEl = dropdown && dropdown.querySelector('.missed-filters__trigger-text');
    if (triggerTextEl) triggerTextEl.textContent = text;

    var mobileTrigger = container.querySelector('[data-mobile-trigger][data-filter-type="' + typeAttr + '"]');
    if (mobileTrigger) mobileTrigger.textContent = mobileText;
  }

  function syncOptionsUI(container, typeKey) {
    var state = getState(container);
    var selected = getDraftSelection(state, typeKey);
    var typeAttr = typeKey === 'showTime' ? 'show-time' : 'presenter';
    var dropdownClass = typeKey === 'showTime' ? '.missed-filters__dropdown--show-time' : '.missed-filters__dropdown--presenter';
    var wraps = Array.from(container.querySelectorAll(dropdownClass));
    var popupEl = (container._missedFiltersPopups || {})[typeAttr];
    if (popupEl) wraps.push(popupEl);
    wraps.forEach(function (wrap) {
      var opts = wrap.querySelectorAll('[data-filter-value]');
      opts.forEach(function (opt) {
        var val = opt.dataset.filterValue;
        var sel = selected.indexOf(val) !== -1;
        opt.setAttribute('aria-selected', sel ? 'true' : 'false');
        opt.classList.toggle('is-selected', sel);
        var box = opt.querySelector('.missed-filters__option-checkbox');
        if (box) box.innerHTML = sel ? CHECKMARK_SVG : '';
      });
    });
  }

  function closeDesktopDropdown(container) {
    if (!container) return;
    container.querySelectorAll('.missed-filters__dropdown').forEach(function (d) {
      d.classList.remove('is-open');
      var trigger = d.querySelector('[data-filter-trigger]');
      var panel = d.querySelector('[data-filter-panel]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('hidden', '');
    });
  }

  function dispatchChange(container) {
    var state = getState(container);
    container.dispatchEvent(new CustomEvent('missed-filters-change', {
      bubbles: true,
      detail: {
        showDates: state.showTime.slice(),
        presenterNames: state.presenter.slice()
      }
    }));
  }

  function getPopupEl(container, type) {
    var popups = container._missedFiltersPopups || {};
    return popups[type] || null;
  }

  function getOpenPopupEl(container) {
    var popups = container._missedFiltersPopups || {};
    var keys = Object.keys(popups);
    for (var i = 0; i < keys.length; i++) {
      if (popups[keys[i]].classList.contains('is-open')) return popups[keys[i]];
    }
    return null;
  }

  function openPopup(container, type) {
    var popup = getPopupEl(container, type);
    if (!popup) return;
    resetDraftFromApplied(container, getTypeKey(type));
    clearSearch(popup);
    popup.hidden = false;
    popup.classList.add('is-open');
    syncOptionsUI(container, type === 'show-time' ? 'showTime' : 'presenter');
  }

  function closePopup(container, type) {
    var popup = type ? getPopupEl(container, type) : getOpenPopupEl(container);
    if (!popup) return;
    popup.hidden = true;
    popup.classList.remove('is-open');
  }

  function initContainer(container) {
    if (!container || container.getAttribute('data-missed-filters-init') === '1') {
      return;
    }
    container.setAttribute('data-missed-filters-init', '1');

    var state = getState(container);

    bindSearch(container);

    /* Stop panel interactions bubbling to document (avoids duplicate outside-close listeners / theme handlers). */
    container.querySelectorAll('[data-filter-panel]').forEach(function (panel) {
      function stopPanelEventBubble(e) {
        e.stopPropagation();
      }
      panel.addEventListener('mousedown', stopPanelEventBubble);
      panel.addEventListener('click', stopPanelEventBubble);
    });

    /* Use event delegation so trigger clicks are always handled */
    container.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-filter-trigger]');
      if (!trigger) return;
      var dropdown = trigger.closest('[data-filter-dropdown]');
      if (!dropdown) return;
      var panel = dropdown.querySelector('[data-filter-panel]');
      var wasOpen = dropdown.classList.contains('is-open');

      e.preventDefault();
      e.stopPropagation();

      /* Close all panels first so only one can be open */
      closeDesktopDropdown(container);

      /* If the clicked one was closed, open it */
      if (!wasOpen) {
        var type = dropdown.getAttribute('data-filter-type');
        var typeKey = getTypeKey(type);
        resetDraftFromApplied(container, typeKey);
        clearSearch(dropdown);
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        if (panel) {
          panel.removeAttribute('hidden');
        }
        syncOptionsUI(container, typeKey);
      }
    });

    /* mousedown: closes as soon as press starts outside (click can reorder oddly with innerHTML updates). */
    document.addEventListener('mousedown', function onDocMouseDown(e) {
      if (container.contains(e.target)) return;
      closeDesktopDropdown(container);
    });

    container.querySelectorAll('[data-mobile-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.getAttribute('data-filter-type');
        openPopup(container, type);
      });
    });

    container.querySelectorAll('[data-popup-close], [data-popup-backdrop]').forEach(function (el) {
      el.addEventListener('click', function () {
        var popup = el.closest('[data-filter-popup]');
        if (popup) closePopup(container, popup.getAttribute('data-filter-type'));
      });
    });

    container.querySelectorAll('[data-popup-done]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var popup = btn.closest('[data-filter-popup]');
        if (popup) {
          var type = popup.getAttribute('data-filter-type');
          var typeKey = getTypeKey(type);
          applyDraftSelection(container, typeKey);
          closePopup(container, popup.getAttribute('data-filter-type'));
          if (typeKey === 'presenter' || typeKey === 'showTime') {
            refreshCrossFilters(container);
          }
          dispatchChange(container);
        }
      });
    });

    container.querySelectorAll('[data-popup-reset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var popup = btn.closest('[data-filter-popup]');
        if (!popup) return;
        var type = popup.getAttribute('data-filter-type');
        var state = getState(container);
        var typeKey = getTypeKey(type);
        state[getDraftKey(typeKey)] = [];
        applyDraftSelection(container, typeKey);
        syncOptionsUI(container, typeKey);
        closePopup(container, type);
        if (typeKey === 'presenter' || typeKey === 'showTime') {
          refreshCrossFilters(container);
        }
        setTimeout(function () { dispatchChange(container); }, 0);
      });
    });

    container.querySelectorAll('[data-desktop-reset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dropdown = btn.closest('[data-filter-dropdown]');
        if (!dropdown) return;
        var type = dropdown.getAttribute('data-filter-type');
        var state = getState(container);
        var typeKey = getTypeKey(type);
        state[getDraftKey(typeKey)] = [];
        applyDraftSelection(container, typeKey);
        syncOptionsUI(container, typeKey);
        closeDesktopDropdown(container);
        if (typeKey === 'presenter' || typeKey === 'showTime') {
          refreshCrossFilters(container);
        }
        setTimeout(function () { dispatchChange(container); }, 0);
      });
    });

    container.querySelectorAll('[data-desktop-done]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dropdown = btn.closest('[data-filter-dropdown]');
        if (dropdown) {
          var type = dropdown.getAttribute('data-filter-type');
          var typeKey = getTypeKey(type);
          applyDraftSelection(container, typeKey);
          if (typeKey === 'presenter' || typeKey === 'showTime') {
            refreshCrossFilters(container);
          }
        }
        closeDesktopDropdown(container);
        dispatchChange(container);
      });
    });
    /* Move popups to <body> AFTER wiring all listeners (elements still in container above). */
    var popupMap = {};
    container.querySelectorAll('[data-filter-popup]').forEach(function (popup) {
      var type = popup.getAttribute('data-filter-type');
      popupMap[type] = popup;
      document.body.appendChild(popup);
    });
    container._missedFiltersPopups = popupMap;
    Object.keys(popupMap).forEach(function (key) {
      bindSearch(popupMap[key]);
    });
  }

  function formatHourLabel(hourValue, showDate, fallbackIndex) {
    var rawHour = hourValue != null ? String(hourValue).trim() : '';
    var hasPlaceholderHour = rawHour === '' || rawHour === '00.00' || rawHour === '00:00';
    if (hasPlaceholderHour && showDate) {
      var fromDate = new Date(showDate);
      if (!isNaN(fromDate.getTime())) {
        return fromDate.toLocaleTimeString('en-GB', { hour: 'numeric', hour12: true }).replace(/\s+/g, ' ');
      }
    }
    if (!rawHour) return 'Hour ' + ((fallbackIndex || 0) + 1);
    var firstSlot = rawHour.split(/\s*(?:to|-|–|—)\s*/i)[0] || rawHour;
    firstSlot = firstSlot
      .replace(/\./g, ':')
      .replace(/\s*([AaPp])[.]?[Mm][.]?$/, ' $1M')
      .replace(/(\d)([AaPp])[Mm]?$/, '$1 $2M')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
    return firstSlot || ('Hour ' + ((fallbackIndex || 0) + 1));
  }

  /** API presenter names often use "First.Last"; show as "First Last" in the UI only. */
  function formatPresenterLabel(raw) {
    return String(raw || '')
      .replace(/\./g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getShowTimeOption(hourData, fallbackIndex) {
    if (!hourData) return null;
    var showDate = hourData.showDate != null ? String(hourData.showDate).trim() : '';
    var hourValue = hourData.hour != null ? String(hourData.hour).trim() : '';
    var dayLabel = '';
    if (showDate) {
      var d = new Date(showDate);
      if (!isNaN(d.getTime())) {
        dayLabel = d.toLocaleDateString('en-GB', { weekday: 'long' });
      }
    }
    var hourLabel = formatHourLabel(hourValue, showDate, fallbackIndex);
    /* Unique per hours[] row so duplicate showDate+hour slots do not merge presenters in cross-filter. */
    var rowIdx = fallbackIndex == null || isNaN(fallbackIndex) ? 0 : fallbackIndex;
    var id = showDate + '|' + (hourValue || hourLabel) + '|' + rowIdx;
    var label = dayLabel && hourLabel ? (dayLabel + ', ' + hourLabel) : (dayLabel || hourLabel || showDate);
    return {
      id: id,
      label: label
    };
  }

  /** When presenterIds is non-empty, returns { showTimeId: true } for hours that match any selected presenter. */
  function getShowTimeIdsForPresenters(hours, presenterIds) {
    if (!presenterIds || presenterIds.length === 0) return null;
    var presenterSet = {};
    presenterIds.forEach(function (p) {
      presenterSet[p] = true;
    });
    var allowed = {};
    (hours || []).forEach(function (h, index) {
      var pn = h.presenterName != null ? String(h.presenterName).trim() : '';
      if (!pn || !presenterSet[pn]) return;
      var opt = getShowTimeOption(h, index);
      if (opt && opt.id) allowed[opt.id] = true;
    });
    return allowed;
  }

  /** When showTimeIds is non-empty, returns { presenterName: true } for hours that match any selected show time. */
  function getPresenterNamesForShowTimes(hours, showTimeIds) {
    if (!showTimeIds || showTimeIds.length === 0) return null;
    var timeSet = {};
    showTimeIds.forEach(function (id) {
      timeSet[id] = true;
    });
    var allowed = {};
    (hours || []).forEach(function (h, index) {
      var opt = getShowTimeOption(h, index);
      if (!opt || !opt.id || !timeSet[opt.id]) return;
      var pn = h.presenterName != null ? String(h.presenterName).trim() : '';
      if (pn) allowed[pn] = true;
    });
    return allowed;
  }

  function mutateShowTimeOptionsForPresenter(state) {
    var all = state.allShowTimeOptions;
    if (!all || !all.length) {
      state.showTimeOptions = [];
      state.showTime = [];
      state.draftShowTime = [];
      return;
    }
    var allowed = getShowTimeIdsForPresenters(state.hours, state.presenter);
    var filtered = allowed === null ? all.slice() : all.filter(function (opt) {
      return allowed[opt.id];
    });
    state.showTimeOptions = filtered;
    state.showTime = state.showTime.filter(function (id) {
      return filtered.some(function (o) {
        return o.id === id;
      });
    });
    state.draftShowTime = state.draftShowTime.filter(function (id) {
      return filtered.some(function (o) {
        return o.id === id;
      });
    });
  }

  function mutatePresenterOptionsForShowTime(state) {
    var all = state.allPresenterOptions;
    if (!all || !all.length) {
      state.presenterOptions = [];
      state.presenter = [];
      state.draftPresenter = [];
      return;
    }
    var allowed = getPresenterNamesForShowTimes(state.hours, state.showTime);
    var filtered = allowed === null ? all.slice() : all.filter(function (opt) {
      return allowed[opt.id];
    });
    state.presenterOptions = filtered;
    state.presenter = state.presenter.filter(function (id) {
      return filtered.some(function (o) {
        return o.id === id;
      });
    });
    state.draftPresenter = state.draftPresenter.filter(function (id) {
      return filtered.some(function (o) {
        return o.id === id;
      });
    });
  }

  /** Two passes each way so presenter/show-time pruning stays consistent when both filters are active. */
  function refreshCrossFilters(container) {
    var state = getState(container);
    mutateShowTimeOptionsForPresenter(state);
    mutatePresenterOptionsForShowTime(state);
    mutateShowTimeOptionsForPresenter(state);
    mutatePresenterOptionsForShowTime(state);
    renderOptions(container, state);
    updateTriggerText(container, 'showTime');
    updateTriggerText(container, 'presenter');
  }

  function setHours(container, hours) {
    if (!container || !Array.isArray(hours)) return;
    var state = getState(container);
    state.hours = hours;

    var showTimeMap = {};
    var presenterNames = {};
    hours.forEach(function (h, index) {
      var showTimeOpt = getShowTimeOption(h, index);
      if (showTimeOpt && showTimeOpt.id) {
        showTimeMap[showTimeOpt.id] = showTimeOpt;
      }
      if (h.presenterName != null && String(h.presenterName).trim()) presenterNames[String(h.presenterName).trim()] = true;
    });
    state.allShowTimeOptions = Object.keys(showTimeMap).map(function (id) {
      return showTimeMap[id];
    });
    state.allPresenterOptions = Object.keys(presenterNames).sort().map(function (t) {
      return { id: t, label: formatPresenterLabel(t) };
    });

    state.showTime = state.showTime.filter(function (id) { return !!showTimeMap[id]; });
    state.presenter = state.presenter.filter(function (id) { return !!presenterNames[id]; });
    state.draftShowTime = state.showTime.slice();
    state.draftPresenter = state.presenter.slice();

    refreshCrossFilters(container);
  }

  function getSelected(container) {
    var state = getState(container);
    return {
      showDates: state.showTime.slice(),
      presenterNames: state.presenter.slice()
    };
  }

  function setProductCount(container, count) {
    if (!container) return;
    container.querySelectorAll('[data-filters-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  window.MissedAuctionsFilters = {
    setHours: setHours,
    getSelected: getSelected,
    setProductCount: setProductCount,
    getShowTimeOption: getShowTimeOption,
    formatPresenterLabel: formatPresenterLabel,
    init: function () {
      document.querySelectorAll('[data-missed-auctions-filters]').forEach(initContainer);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.MissedAuctionsFilters.init();
    });
  } else {
    window.MissedAuctionsFilters.init();
  }
})();
